import React, { useState, useCallback } from 'react';
import * as departmentManagementAction from "../redux/store-sarang/department/department-management.store";
import DepartmentHelper from '../pages/list-department/helper/department-helper';

export const useLookupDepartment = () => {
    const [departmentAll, setDepartmentAll] = useState([]);

    const getListNoPermiss = useCallback(async () => {
        try {
            const res = await departmentManagementAction.GetListNoPermiss();
            if (res && res.content && res.content.items) {
                const preparedData = DepartmentHelper.PrepareSortData(res.content.items);
                setDepartmentAll(preparedData);
                return preparedData;
            }
            return [];
        } catch (err) {
            console.error(err);
            throw err;
        }
    }, []);

    const getLookupDepartment = useCallback(async () => {
        try {
            const res = await departmentManagementAction.GetLookupDepartment();
            if (res && res.content && res.content.items) {
                const preparedData = DepartmentHelper.PrepareSortData(res.content.items);
                setDepartmentAll(preparedData);
                return preparedData;
            }
            return [];
        } catch (err) {
            console.error(err);
            throw err;
        }
    }, []);

    const departmentOptions = React.useMemo(() => DepartmentHelper.RenderOptions(departmentAll), [departmentAll]);

    return { departmentAll, departmentOptions, getListNoPermiss, getLookupDepartment };
};
